import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import CasesTable from "@/components/CasesTable";
import { useI18n } from "@/context/I18nContext";

export default function MyCases() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-2xl font-medium text-white">{L("Le mie pratiche", "My cases", "Meine Fälle")}</h2>
        <Button asChild className="bg-gold text-navy hover:bg-gold-hover"><Link to="/avvia-recupero"><Plus className="h-4 w-4 mr-1.5" />{L("Nuova pratica", "New case", "Neuer Fall")}</Link></Button>
      </div>
      <CasesTable endpoint="/cases" basePath="/portal/cases" />
    </div>
  );
}
